<template>
  <div>
    <nav-breadcrumb :menu="[{label: '贷款审核'}]"/>
    <div class="bg-purple of">
        <el-tabs v-model="transactionStatus">
          <el-tab-pane label="待审核" name="Pending Approval" />
          <el-tab-pane label="已审核" name="Processing,Ready,Settled" />
        </el-tabs>
        <div class="xzpadd10 of">
          <data-table
              :table-data="tableData"
              :columns="columns"
              :page.sync="page"
              :pageSize.sync="pageSize"
              :filters.sync="filters"
              :actions="actions"
            />
        </div>
      </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import Status2CN from "../../filters/Status2CN";
  import moment from 'moment'
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "FinancingList",
        data(){
          return{
            transactionStatus: 'Pending Approval',
            tableData: {
              count: 0,
              data: []
            },
              roleData:{},
            dealerTypeOptions:[],
            page: 1,
            pageSize: 20,
            actions: [
              /*{
                label: '新增',
                class: 'el-icon-plus',
                clickHandler: ()=>{
                  this.$router.push({
                    path: 'add'
                  })
                }
              }*/
            ],
            filters: {
              labelWidth: '150px',
              form: {
                fi__transactionNo:'',
                fi__customerName:'',
                c__customerContactNo:'',
                fi__intendedUse:'',
                fi__transactionDate:[],
              },
              columns: [
                {
                  label: '贷款编号',
                  component: 'el-input',
                  field: 'fi__transactionNo',

                },
                {
                  label: '客户姓名',
                  component: 'el-input',
                  field: 'fi__customerName',

                },
               /* {
                  label: '客户手机号',
                  component: 'el-input',
                  field: 'c__customerContactNo',

                },*/
                /*{
                  label: '贷款用途',
                  component: 'el-input',
                  field: 'fi__intendedUse',
                  span: 12
                },*/
                {
                  label: '申请时间',
                  component: 'date-range-picker',
                  field: 'fi__transactionDate',
                  op: ['gteq', 'lteq'],
                  span: 12
                },

              ],
              onSubmit:()=>{
                this.page = 1
                this.getData()
              }
            }
          }
        },
        computed:{
          columns: function(){
            return [
              {
                type: 'index'
              },
              {
                label: '贷款编号',
                field: 'fi__transactionNo'
              },
              {
                label: '客户姓名',
                field: 'fi__customerName'
              },
              /*{
                label: '客户手机号',
                field: 'c__customerContactNo'
              },*/
              {
                label: '渠道商',
                field: 'd__dealerName'
              },
            /*  {
                label: '贷款用途',
                field: 'fi__intendedUse'
              },*/
              {
                label: '贷款金额',
                field: 'fi__totalAmount',
                formatter: function (r,c,v) {
                  return formatMoney(v)
                },
              },
              {
                label: '贷款利率(%)',
                field: 'fi__interestRate',
                formatter: function (r,c,v) {
                  return v+'%'+'('+Status2CN(r.fi__interestType)+')'
                }
              },
              {
                label: '申请时间',
                field: 'fi__transactionDate',
                formatter: function (r,c,v) {
                  return moment(v).format('YYYY-MM-DD')
                }
              },
              {
                label: '状态',
                field: 'fi__transactionStatus',
                formatter: function (r,c,v) {
                  return v=='Pending Approval'?'待审核':Status2CN('Financing_'+v)
                }
              },
                {
                    label: '当前待审批节点',
                    field: 'fi__nodeName',
                    formatter: function (r,c,v) {
                        if(r.fi__transactionStatus=='Rejected'){
                            v=''
                        }
                        return v
                    }
                },
              {
                label: '操作',
                opts:[
                  {
                      label: row=> {
                          let name  = '审核';
                          (this.tableData.variables.procInfo||[]).forEach(item=>{
                              if(item.roleId==row.fi__roleId){
                                  name = item.name
                              }
                          })

                          return name
                      },
                    class: 'el-icon-success',
                    clickHandler: (index, row) => {
                      this.$router.push({
                        name: 'ApproveFinancingView',
                        query: {
                          'transactionId': row.fi__transactionId,

                        }
                      })
                    },
                    conditions: row=> {
                      return row.fi__hasRole == 'true' &&row.fi__transactionStatus=='Pending Approval'

                    }
                  },
                  {
                    label: '查看',
                    class: 'el-icon-view',
                    clickHandler: (index, row) => {
                      this.$router.push({
                        name: 'ApproveFinancingViewView',
                        query: {
                          'transactionId': row.fi__transactionId,
                          'action': 'View'

                        }
                      })
                    },
                    conditions: row=> {
                      return row.fi__transactionStatus!='Pending Approval'

                    }
                  },
                    {
                        label: '撤回',
                        class: ' el-icon-back',
                        clickHandler: (index, row) => {
                            this.$confirm('是否确认撤回贷款申请？一旦撤回，审核人将无法再审核','撤回贷款')
                                .then(()=> {
                                    xhr.RevokeApprovingFinancing(
                                        {
                                            'fi.transactionId': row.fi__transactionId,
                                        },
                                        res=> {
                                            try{
                                                if(res.data.status == 'success') {
                                                    this.getData()
                                                }else{
                                                    this.$message.error(res.data.msgs[0].text)
                                                }

                                            }catch (e) {

                                                this.$message.error(error.msgs[0].text)

                                            }
                                        }
                                    )
                                })
                                .catch(()=> {

                                })
                        },
                        conditions: row=> {
                            return row.fi__transactionStatus=='Pending Approval'&&this.$store.state.userInfo.u__userId === row.fi__createdBy

                        }
                    },
                ]
              }
            ]
          },
          filterParams: {
            get: function() {
              return {
                pageSize: this.pageSize,
                pageOffset: (this.page - 1) * this.pageSize,
                   'xlist.search.fi.transactionStatus' : this.transactionStatus,
                   'xlist.search.fi.transactionStatus.op' : 'in',
                'xlist.sort.dataField': 'fi.transactionDate',
                'xlist.sort.order': 'desc'
              }
            },
            set:function (newVal) {

            }
          }
        },
        watch: {
          filterParams: function () {
            this.getData()
          },
        },

        mounted() {
          this.getData()
        },
        methods: {
          getData: function () {
            xhr.getFinancingFangList(
              Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
              res => {
                try {
                  this.tableData = res.data
                    this.roleData = res.data.variables
                    this.tableData.data.forEach(item=>{
                        item.fi__nodeName = (this.tableData.variables.procInfo.find(item2=>item2.type ===item.fi__nodeType )||{}).name

                    })
                } catch (e) {

                }
              })
          },

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/FinancingList.vue